import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const RegisterAPI = createApi({
  reducerPath: "RegisterAPI",
  baseQuery: fetchBaseQuery({ baseUrl: BaseUrl,
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
   }),
  endpoints: (builder) => ({
    submitRegisterForm: builder.mutation({
      query: (formData) => ({
        url: "user/user-register",
        method: "POST",
        body: formData,
      }),
    }),

    submitLoginForm: builder.mutation({
      query: (formData) => ({
        url: "user/user-login",
        method: "POST",
        body: formData,
      }),
    }),

    submitForgotPassword: builder.mutation({
      query: (formData) => ({
        url: "forgot-password",
        method: "POST",
        body: formData,
      }),
    }),
    submitForgotOTP: builder.mutation({
      query: (formData) => ({
        url: "verify-otp",
        method: "POST",
        body: formData,
      }),
    }),
    
    resetPassword: builder.mutation({
      query: (formData) => ({
        url: "reset-password",
        method: "POST",
        body: formData,
      }),
    }),
  }),
});

export const { useSubmitRegisterFormMutation, useSubmitLoginFormMutation, useSubmitForgotPasswordMutation , useSubmitForgotOTPMutation, useResetPasswordMutation} =
  RegisterAPI;
